<template>
  <div class="standardsDirectory hideScrollbar">
    <div v-for="(item,index) in standardsContents.slice(1)" :key="index">
      <div class="item" v-if="item.clause_title" @click="scroll2Top(item)"
        v-html="$options.filters.addTextIndent(item.clause_code,item.clause_title)"></div>
    </div>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  import {
    count
  } from "@/misc/util.js";
  export default {
    props: {
      standardsContents: Array
    },
    methods: {
      scroll2Top(item) {
        Bus.$emit("code", item.clause_code);
      }
    },
    filters: {
      // par: 默认传过来的item.clclause_contents
      addTextIndent(p1, p2) {
        // 按级别增加缩进
        var n = Math.max(count("-", p1) - 2, 0);
        if (n == 0) {
          return (
            "<div style='font-weight:700;margin-top:0.1rem'> <b>" +
            p2 +
            "</b>  </div>"
          );
        } else if (n == 1) {
          return p2;
        } else {
          return null;
        }
      }
    }
  };
</script>

<style scoped>
  .standardsDirectory {
    width: calc(100% - 0.1rem);
    height: calc(100vh - 1.4rem);
    margin-top: 0.2rem;
  }

  .standardsDirectory .item {
    width: 100%;
    margin-top: 0.0005rem;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
</style>